export default "__VITE_PUBLIC_ASSET__e5b1ff40__"